import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SortbyPipe } from '@netfoundry-ui/ui/pipes';
import {
    HostService,
    NETWORK_SERVICE,
    NetworkServiceV2,
    ProviderService,
    RegionService,
    NetworkControllerService,
    AllocatedIpService,
} from '@netfoundry-ui/shared/apiv2';
import { AgentService, ApiService, AuthProviderService, FrontdoorTokenService } from '@netfoundry-ui/shared/services';
import { Agent, AuthProvider, FrontdoorToken, Environment, ENVIRONMENT } from '@netfoundry-ui/shared/model';
import { GrowlerData, GrowlerService } from '@netfoundry-ui/shared/growler';
import { ActivatedRoute, Router } from '@angular/router';
import _, { cloneDeep, unset, isEmpty } from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartType } from 'chart.js';
import moment from 'moment';
import { AUTHENTICATION } from '@netfoundry-ui/shared/authorization';
import { JsonViewComponent } from '@netfoundry-ui/ui/json-view';
import { Subject, Subscription } from 'rxjs';
import { valid } from 'semver';

@Component({
    selector: 'app-certificate-request-token-modal',
    templateUrl: './certificate-request-token-modal.component.html',
    styleUrls: ['./certificate-request-token-modal.component.scss'],
    standalone: false
})
export class CertificateRequestTokenModalComponent implements OnInit {

    model: FrontdoorToken;
    orgId;
    frontdoorId;
    networkControllerId;
    networkId;
    isEditing = false;
    token;
    tokenURL;
    processing = false;
    isV2;
    basePath = '';
    @Input() isModal = false;
    @Input() formData: any = {};
    close: EventEmitter<any> = new EventEmitter<any>();
    moreActions: any[] = [];
    nameError = false
    nameErrorMessage
    showError= false;
    errorMessage;
    saveSubject = new Subject<boolean>;
    mappingConfigUpdateSubject = new Subject<boolean>;
     formInit = false;
    protected isLoading = false;
    subscription: Subscription = new Subscription();
    initData: any = {};
    @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();
    previousRoute;
    protected usePreviousLocation = true;
    baseHref: any;
    _dataChange = false;
    formView = 'simple';
    @Input() entityId: string;
    commonNameError = false;
    commonNameMessage
    organizationalUnitError = false;
    organizationalUnitMessage
    organizationError = false;
    organizationMessage
    validYearsError = false;
    validYearsMessage




    constructor(
        private svc: FrontdoorTokenService,
        private agentService: AgentService,
        private apiService: ApiService,
        public growlerService: GrowlerService,
        @Inject(ENVIRONMENT) private environment: Environment,
        protected router?: Router,
        protected route?: ActivatedRoute,
    ) {
    this.previousRoute = router?.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();
        this.subscription.add(
            this.route?.params?.subscribe(params => {
                const id = params['id'];
                if (isEmpty(id)) {
                    this.entityId = 'create';
                } else {
                  this.entityId = id;
                }
            })
        );
        this.subscription.add(
            router?.events.subscribe((event: any) => {
                  if (!event?.snapshot?.routeConfig?.path) {
                      return;
                  }
                  const pathSegments = event.snapshot.routeConfig.path.split('/');
                  this.basePath = pathSegments[0];
                
            })
        );
        this.initBaseHref();

    }

    ngOnInit() {
        this.subscription.add(
            this.apiService.currentTenant.subscribe((tenant) => {
                this.orgId = tenant.id
                this.agentService.getAccountById(this.orgId).subscribe((frontdoor: any) => {
                    this.frontdoorId = frontdoor.id
                    if(frontdoor.version === 1) {
                        this.isV2 = false
                    } else {
                        this.isV2 = true
                    }
                    if (this.entityId === 'create') {
                        this.formData = new FrontdoorToken();
                        this.initData = cloneDeep(this.formData);
                        this.entityUpdated();
                        return;
                    } else {
                        const originDomain = window?.location?.hostname || this.environment.originDomain
                        const originPort = window?.location?.port || this.environment.originPort;
                        const originProtocol = window?.location?.protocol || 'https:';
                        let uiLink = originProtocol + '//' + originDomain;
                        if (originPort) {
                            uiLink = uiLink + ':' + originPort;
                        }
                        if(this.isV2) {
                            this.tokenURL = uiLink + '/frontdoor/v2/certificate-upload' + '?frontdoorId=' + this.formData.frontdoorId + '&token=' + this.formData.token
                        } else {
                            this.tokenURL = uiLink + '/frontdoor/certificate-upload' + '?frontdoorId=' + this.formData.frontdoorId + '&token=' + this.formData.token
                        }
                        this.isEditing = true;
                        this.isLoading = true;
                        this.getSingleCSR();
                    }
                })
            })
        );
    }


        copyText(text: string) {
  navigator.clipboard.writeText(text).then(() => {
        this.growlerService.show(
        new GrowlerData(
            'success',
            'Success',
            'Copied to clipboard',
            'Share link has been copied to your clipboard'
        )
        );
    });
    }

        closeForm(refresh = true, ignoreChanges = false, data?, event?) {
      if (!ignoreChanges && this._dataChange) {
          const confirmed = confirm('You have unsaved changes. Do you want to leave this page and discard your changes or stay on this page?');
          if (!confirmed) {
              return;
          }
      }
      if (this.isModal) {
          this.closeModal(refresh, ignoreChanges);
      } else {
          this.returnToListPage();
      }
    }

    returnToListPage() {
      // Certificate Request Tokens is a tab on the TCP shares page, not a page of its own.
      this.router?.navigateByUrl(`${this.basePath}/tcp-shares?tab=request-tokens`);
    }

      closeModal(refresh = true, ignoreChanges = false, data?: any, event?: any): void {
        this.close.emit({refresh: refresh});
        if (event) {
            event.stopPropagation();
        }
    }

        initBaseHref() {
        try {
            const base = document?.querySelector('base');
            this.baseHref = base ? base.getAttribute('href') : '/';
        } catch (error) {
            this.baseHref = '/';
        }
    }

    entityUpdated() {
            if (this.formData.id) {
            }
            
            unset(this.formData, '_links');
            this.initData = cloneDeep(this.formData);
        }

    headerActionRequested(action: any) {
        switch(action.name) {
            case 'save':
                this.save();
                break;
            case 'close':
                this.closeForm();
                break;
            case 'toggle-view':
                this.formView = action.data;
                break;
            }
        }

    getSingleCSR() {
            return this.svc.getCSRById(this.frontdoorId, this.entityId, this.isV2).subscribe({
        next: (entity: FrontdoorToken) => {
            this.formData = entity;
            const originDomain = window?.location?.hostname || this.environment.originDomain
            const originPort = window?.location?.port || this.environment.originPort;
            const originProtocol = window?.location?.protocol || 'https:';
            let uiLink = originProtocol + '//' + originDomain;
            if (originPort) {
                uiLink = uiLink + ':' + originPort;
            }
            if(this.isV2) {
                this.tokenURL =  uiLink + '/frontdoor/v2/certificate-upload' + '?frontdoorId=' + this.formData.frontdoorId + '&token=' + this.formData.token
            } else {
                this.tokenURL =  uiLink + '/frontdoor/certificate-upload' + '?frontdoorId=' + this.formData.frontdoorId + '&token=' + this.formData.token
            }
            this.initData = cloneDeep(this.formData);
            this.entityUpdated();
            this.isLoading = false;
        },
        error: (err) => {
            this.growlerService.show(
            new GrowlerData(
                'error',
                'Error',
                'Error retrieving certificate request token.',
            )
        );
        }
        }) 
    }

        save(event?: any) {
        this.processing = true;
        this.isLoading = true;

        
        const proms = [];

        if (this.isEditing) {
            this.saveSubject.next(true);
            const updateSubjectPromise = new Promise<boolean>((resolve) => {
            // Note: Consider taking(1) so this doesn't hang
            this.mappingConfigUpdateSubject.asObservable().subscribe((wasUpdated: boolean) => {
                resolve(wasUpdated);
            });
            });
            proms.push(updateSubjectPromise);
        } else {
            // If not editing, we push 'true' so the Promise.all logic stays consistent
            proms.push(Promise.resolve(true));
        }

        const httpCall = this.isEditing 
            ? this.svc.update( this.formData, this.frontdoorId,  this.formData.id, this.isV2)
            : this.svc.create(this.formData, this.frontdoorId, this.isV2 );

        const requestPromise = new Promise((resolve, reject) => {
            httpCall.subscribe({
            next: (result: any) => {
                if (this.isModal) {
                this.closeModal(true, true);
                } else {
                this.initData = this.formData;
                this.formData = result;
                this._dataChange = false;
                this.isLoading = false;
                }
                resolve(true);
            },
            error: (err) => {
                this.processErrors(err);
                this.isLoading = false;
            }
            });
        });


        proms.push(requestPromise);

        // 3. Finalize
        Promise.all(proms)
            .then((results) => {
            // results[0] is the Subject, results[1] is the HTTP call
            if (results.every(res => res === true)) {
                this.returnToListPage();
                // TODO: Success message
            }
            })
            .catch(err => {
            // Handle errors here
            })
            .finally(() => {
            this.processing = false;
            this.isLoading = false;
            });
        }


        processErrors(errorResponse: any) {
            const errors: string[] = errorResponse?.error?.errors || [];
            const organizationalUnitError = errors.find(e => e.includes('organizationalUnit'));
            const commonNameError = errors.find(e => e.includes('commonName'));
            const organizationError = errors.find(e => e.includes('organization'));
            const validYearsError = errors.find(e => e.includes('validYears'));
            const nameError = errors.find(e => e.includes('name'))
            if(organizationalUnitError) {
                this.organizationalUnitError = true;
                this.organizationalUnitMessage =  organizationalUnitError.split(':').slice(1).join(':').trim();
            }
            if(organizationError) {
                this.organizationError = true;
                this.organizationMessage =  organizationError.split(':').slice(1).join(':').trim();
            }
            if(commonNameError) {
                this.commonNameError = true;
                this.commonNameMessage =  commonNameError.split(':').slice(1).join(':').trim();
            }
            if(validYearsError) {
                this.validYearsError = true;
                this.validYearsMessage =  validYearsError.split(':').slice(1).join(':').trim();
            }
            if(nameError) {
                this.nameError = true;
                this.nameErrorMessage =  nameError.split(':').slice(1).join(':').trim();
            }
            else {
                this.growlerService.show(
                        new GrowlerData(
                            'error',
                            'Certificate request token save request failed',
                            'Certificate request token save request has failed.'
                    )
            );
        }
            
}




    /**
     * True when this form is showing an existing entity. Derived from the route/input
     * rather than the loaded record, so the header title doesn't briefly read
     * "Create New ..." while the record is still being fetched.
     */
    get isExistingEntity(): boolean {
        return !isEmpty(this.formData?.id) || (!isEmpty(this.entityId) && this.entityId !== 'create');
    }

}
